export enum APPLICATION_MODULE {
  APPLICATION_PROGRESS = 'applicationProgress',

  PROGRAMME_CHOICES = 'programmeChoices',

  HKPFS = 'hkpfs',
  RESEARCH_EXPERIENCES = 'researchExperiences',

  ACADEMIC_QUALIFICATIONS = 'academicQualifications',
  LANGUAGE_QUALIFICATIONS = 'languageQualifications',
  OTHER_TESTS = 'otherTests',
  PUBLICATIONS = 'publications',
  MERITS = 'merits',
  ACADEMIC_REFEREES = 'academicReferees',

  EMPLOYMENT = 'employment',
  EXTRA_ACTIVITIES = 'activities',
  ADDITIONAL_DOCUMENTS = 'additionalDocuments',
  TRAINING_EXPERIENCES = 'trainingExperiences',
  PROFESSIONAL_QUALIFICATIONS = 'ProfessionalQualifications',

  SUPPORTING_DOCUMENTS = 'supportingDocuments',
  CURRICULUM_VITAE = 'curriculumVitae',
  RESEARCH_PROPOSAL = 'researchProposal',
  PERSONAL_STATEMENT = 'personalStatement',
  IDENTIFICATION_DOCUMENT = 'identificationDocument',
  STUDY_PLAN = 'studyPlan',

  DISTINCTIVE_SCHOLARSHIP = 'distinctiveScholarship',

  DECLARATION = 'declaration',
  PROOF_DOCUMENT = 'proofDocument',
}

export enum ACTIVITY_TYPE {
  COMMUNITY_SERVICE = 'COMMUNITY_SERVICE',
  EXTRACURRICULAR_ACTIVITY = 'EXTRACURRICULAR_ACTIVITY',
}

export enum REFEREE_TITLE_TYPE {
  PROF = 'Prof',
  DR = 'Dr',
  MR = 'Mr',
  MS = 'Ms',
  MRS = 'Mrs',
  MISS = 'Miss',
  SIR = 'Sir',
  MADAM = 'Madam',
  OTHERS = 'Others',
}
export enum MODE_OF_EMPLOYMENT {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
}

export enum FIELD_OF_EMPLOYMENT {
  ACCOUNTING_AUDITING = 'ACCOUNTING_AUDITING',
  ARCHITECTURE_SURVEYING = 'ARCHITECTURE_SURVEYING',
  ADVERTISING_MARKETING = 'ADVERTISING_MARKETING',
  BANKING_FINANCE = 'BANKING_FINANCE',
  BIOTECHNOLOGY_CHEMICALS = 'BIOTECHNOLOGY_CHEMICALS',
  BUILDING_CONSTRUCTION = 'BUILDING_CONSTRUCTION',
  CIVIL_AND_SOCIAL_SERVICES = 'CIVIL_AND_SOCIAL_SERVICES',
  COMMUNICATION_PUBLIC_RELATIONS = 'COMMUNICATION_PUBLIC_RELATIONS',
  DESIGN = 'DESIGN',
  EDUCATION = 'EDUCATION',
  ENGINEERING = ' ENGINEERING',
  HEALTH_CARE = 'HEALTH_CARE',
  HOTEL_CATERING = 'HOTEL_CATERING',
  INFORMATION_TECHNOLOGY = 'INFORMATION_TECHNOLOGY',
  INSURANCE = 'INSURANCE',
  LEGAL = 'LEGAL ',
  LOGISTICS_TRANSPORT = 'LOGISTICS_TRANSPORT',
  MANUFACTURING = 'MANUFACTURING',
  MEDIA = 'MEDIA',
  MERCHANDISING_TRADING = 'MERCHANDISING_TRADING',
  PRINTING_PUBLISHING = 'PRINTING_PUBLISHING',
  PUBLIC_UTILITIES = 'PUBLIC_UTILITIES',
  REAL_ESTATE = 'REAL_ESTATE',
  TELECOMMUNICATIONS = 'TELECOMMUNICATIONS',
  TEXTILES_AND_GARMENTS = 'TEXTILES_AND_GARMENTS',
  TOURISM_TRAVEL = 'TOURISM_TRAVEL',
  WHOLESALE_AND_RETAIL = 'WHOLESALE_AND_RETAIL',
  OTHERS = 'OTHERS',
}

export enum LANGUAGE_QUALIFICATION_TEST_TYPE {
  IELTS = 'IELTS',
  TOEFL = 'TOEFL',
}

export enum OTHER_TEST_TYPE {
  GMAT_ONLINE = 'GMAT_ONLINE',
  GMAT_FOCUS = 'GMAT_FOCUS',
  GMAT = 'GMAT',
  GRE = 'GRE',
}

export enum GPA_TYPE {
  HK = 'HK',
  US = 'US',
  MAINLAND_CHINA = 'Mainland',
  UK = 'UK',
}
export enum STUDY_MODE {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
}

export enum PROGRAMME_NAME {
  DOCTOR_OF_PHILOSOPHY = 'DOCTOR_OF_PHILOSOPHY',
  MASTER_OF_PHILOSOPHY = 'MASTER_OF_PHILOSOPHY',
}

export enum PROGRAMME_PLAN_STATUS {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Closed = 'Closed',
}

export enum PROGRAMME_TYPE {
  GENERAL_PROGRAMME = 'GENERAL_PROGRAMME',
  SPONSORED_PHD_PROGRAMME = 'SPONSORED_PHD_PROGRAMME',
  DUAL_PHD_DEGREE_PROGRAMME = 'DUAL_PHD_DEGREE_PROGRAMME',
  COLLABORATIVE_PHD_DEGREE_PROGRAMME = 'COLLABORATIVE_PHD_DEGREE_PROGRAMME',
  // when backend enum is updated
  // JOINT_PHD_DEGREE_PROGRAMME = 'JOINT_PHD_DEGREE_PROGRAMME',
}

export enum PROFESSIONAL_QUALIFICATION_PROFESSIONAL_FIELD {
  ACCOUNTING_AUDITING = 'ACCOUNTING_AUDITING',
  ARCHITECTURE_SURVEYING = 'ARCHITECTURE_SURVEYING',
  ADVERTISING_MARKETING = 'ADVERTISING_MARKETING',
  BANKING_FINANCE = 'BANKING_FINANCE',
  BIOTECHNOLOGY_CHEMICALS = 'BIOTECHNOLOGY_CHEMICALS',
  BUILDING_CONSTRUCTION = 'BUILDING_CONSTRUCTION',
  CIVIL_AND_SOCIAL_SERVICES = 'CIVIL_AND_SOCIAL_SERVICES',
  COMMUNICATION_PUBLIC_RELATIONS = 'COMMUNICATION_PUBLIC_RELATIONS',
  DESIGN = 'DESIGN',
  EDUCATION = 'EDUCATION',
  ENGINEERING = ' ENGINEERING',
  HEALTH_CARE = 'HEALTH_CARE',
  HOTEL_CATERING = 'HOTEL_CATERING',
  INFORMATION_TECHNOLOGY = 'INFORMATION_TECHNOLOGY',
  INSURANCE = 'INSURANCE',
  LEGAL = 'LEGAL ',
  LOGISTICS_TRANSPORT = 'LOGISTICS_TRANSPORT',
  MANUFACTURING = 'MANUFACTURING',
  MEDIA = 'MEDIA',
  MERCHANDISING_TRADING = 'MERCHANDISING_TRADING',
  PRINTING_PUBLISHING = 'PRINTING_PUBLISHING',
  PUBLIC_UTILITIES = 'PUBLIC_UTILITIES',
  REAL_ESTATE = 'REAL_ESTATE',
  TELECOMMUNICATIONS = 'TELECOMMUNICATIONS',
  TEXTILES_AND_GARMENTS = 'TEXTILES_AND_GARMENTS',
  TOURISM_TRAVEL = 'TOURISM_TRAVEL',
  WHOLESALE_AND_RETAIL = 'WHOLESALE_AND_RETAIL',
  OTHERS = 'OTHERS',
}

export enum PROFESSIONAL_QUALIFICATION_PROFESSIONAL_QUALIFICATION {
  AFFILIATE = 'AFFILIATE',
  APPRENTICE_CRAFT_CERTIFICATE = 'APPRENTICE_CRAFT_CERTIFICATE',
  CERTIFICATE_OF_COMPETENCE = 'CERTIFICATE_OF_COMPETENCE',
  CERTIFICATE_OF_REGISTRATION = 'CERTIFICATE_OF_REGISTRATION',
  CHARTERED_QUALIFIED_REGISTERED_PROFESSIONAL = 'CHARTERED_QUALIFIED_REGISTERED_PROFESSIONAL',
  COMPANION = 'COMPANION',
  FELLOW = 'FELLOW',
  INCORPORATE_ENGINEER = 'INCORPORATE_ENGINEER',
  LICENTIATE = 'LICENTIATE',
  MEMBER = 'MEMBER',
  PASS_ENGG_COUNCIL_I = 'PASS_ENGG_COUNCIL_I',
  PASS_ENGG_COUNCIL_II = 'PASS_ENGG_COUNCIL_II',
  PROBATIONARY_MEMBER = 'PROBATIONARY_MEMBER',
  PROFESSIONAL_ASSOCIATE = 'PROFESSIONAL_ASSOCIATE',
  REGISTERED_CHINESE_MEDICINE_PRACTITIONER = 'REGISTERED_CHINESE_MEDICINE_PRACTITIONER',
  TECHNICIAN = 'TECHNICIAN',
  TEACH_INSTRUCT_QUA = 'TEACH_INSTRUCT_QUA',
  SEC_TECHNICAL_SKILL = 'SEC_TECHNICAL_SKILL',
}

export enum PROFESSIONAL_QUALIFICATION_AWARD_BODY {
  INTERNATIONAL_SOCIETY_FOR_PROSTHETICS_AND_ORTHOTICS = 'INTERNATIONAL_SOCIETY_FOR_PROSTHETICS_AND_ORTHOTICS',
  OCCUPATIONAL_THERAPISTS_BOARD_HONG_KONG = 'OCCUPATIONAL_THERAPISTS_BOARD_HONG_KONG',
  PHYSIOTHERAPISTS_BOARD_HONG_KONG = 'PHYSIOTHERAPISTS_BOARD_HONG_KONG',
  HONG_KONG_SOCIETY_OF_CERTIFIED_PROSTHETIST_ORTHOTISTS = 'HONG_KONG_SOCIETY_OF_CERTIFIED_PROSTHETIST_ORTHOTISTS',
  PHYSIOTHERAPY_BOARD_OF_NEW_ZEALAND = 'PHYSIOTHERAPY_BOARD_OF_NEW_ZEALAND',
  HEALTH_PROFESSIONS_COUNCIL_HPC = 'HEALTH_PROFESSIONS_COUNCIL_HPC',
  ALLIED_HEALTH_PROFESSIONAL_COUNCIL_SINGAPORE = 'ALLIED_HEALTH_PROFESSIONAL_COUNCIL_SINGAPORE',
  IRISH_SOCIETY_OF_CHARTERED_PHYSIOTHERAPISTS = 'LRISH_SOCIETY_OF_CHARTERED_PHYSIOTHERAPISTS',
  PHYSICAL_THERAPY_BOARD = 'PHYSICAL_THERAPY_BOARD',
  THE_AUSTRALIAN_PHYSIOTHERAPY_COUNCIL = 'THE_AUSTRALIAN_PHYSIOTHERAPY_COUNCIL',
  CANADIAN_ALLIANCE_OF_PHYSIOTHERAPY_REGULATORS = 'CANADIAN_ALLIANCE_OF_PHYSIOTHERAPY_REGULATORS',
  AMERICAN_PHYSICAL_THERAPY_ASSOCIATION = 'AMERICAN_PHYSICAL_THERAPY_ASSOCIATION',
  NATIONAL_BOARD_FOR_CERTIFICATION_IN_OCCUPATIONAL_THERAPY = 'NATIONAL_BOARD_FOR_CERTIFICATION_IN_OCCUPATIONAL_THERAPY',
  OCCUPATIONAL_THERAPY_BOARD_OF_AUSTRALIA = 'THERAPY_OCCUPATIONAL_THERAPY_BOARD_OF_AUSTRALIA',
  OTHERS = 'OTHERS',
}

export enum PROGRAMME {
  PHD = 'DOCTOR_OF_PHILOSOPHY',
  MPHIL = 'MASTER_OF_PHILOSOPHY',
}

export const STUDY_MODE_DISPLAY_MAP: Record<STUDY_MODE, string> = {
  [STUDY_MODE.FULL_TIME]: 'Full-time',
  [STUDY_MODE.PART_TIME]: 'Part-time',
};

export const PROGRAMME_DISPLAY_MAP: Record<string, string> = {
  [PROGRAMME.PHD]: ' PhD',
  [PROGRAMME.MPHIL]: ' MPhil',
};

export const PROGRAMME_TYPE_DISPLAY_MAP: Record<string, string> = {
  [PROGRAMME_TYPE.GENERAL_PROGRAMME]: 'General',
  [PROGRAMME_TYPE.DUAL_PHD_DEGREE_PROGRAMME]: 'Dual',
  [PROGRAMME_TYPE.COLLABORATIVE_PHD_DEGREE_PROGRAMME]: 'Joint',
};

export enum ADDITIONAL_DOCS_TYPE {
  ACTIVITY = 'Activity/Volunteer/Service',
  CURRICULUM = 'Curriculum Vitae',
  EMPLOYMENT = 'Employment Recommendation',
  AWARD = 'Prize and Award',
  QUALIFICATION = 'Professional Qualification',
  PUBLICATION = 'Publication',
  RESEARCH = 'Research Proposal(GSB/1A)',
  TRAINING = 'Training/Internship',
  ADDITIONAL_REFERENCE_LETTER = 'Additional Reference Letter',
  PERSONAL_STATEMENT = 'Personal Statement',
  GSB_J4 = 'Study Plan for the Dual PhD Degree and Joint PhD Supervision Programmes Leading to a PolyU Degree (GSB/J4)',
  STUDY_PLAN = 'Study Plan',
  IDENTIFICATION_DOCUMENT = 'Identification Document',
  OTHERS = 'Others',
}

export enum QUALIFICATION_MEANS {
  COURSEWORK = 'COURSEWORK',
  COURSEWORK_RESEARCH = 'COURSEWORK_RESEARCH',
  RESEARCH = 'RESEARCH',
}

export enum QUALIFICATION_STATUS_TYPES {
  GRADUATED = 'GRADUATED',
  WILL_COMPLETE_STUDY_BEFORE = 'WILL_COMPLETE_STUDY_BEFORE',
  WILL_GRADUATE_IN_AFTER = 'WILL_GRADUATE_IN_AFTER',
  COMPLETED_WITHOUT_AWARD = 'COMPLETED_WITHOUT_AWARD',
  WITHDRAW = 'WITHDRAW',
}

export enum AWARD_CLASSIFICATION {
  HIGHEST_HONOURS_SUMMA_CUM_LAUDE = 'HIGHEST_HONOURS_SUMMA_CUM_LAUDE',
  FIRST_CLASS_HONOURS = 'FIRST_CLASS_HONOURS',
  HIGH_HONOURS_MAGNA_CUM_LAUDE = 'HIGH_HONOURS_MAGNA_CUM_LAUDE',
  SECOND_UPPER_DIVISION_I_CLASS_HONOURS = 'SECOND_UPPER_DIVISION_I_CLASS_HONOURS',
  SECOND_UPPER_DIVISION_II_CLASS_HONOURS = 'SECOND_UPPER_DIVISION_II_CLASS_HONOURS',
  THIRD_CLASS_HONOURS = 'THIRD_CLASS_HONOURS',
  HONOURS_CUM_LAUDE = 'HONOURS_CUM_LAUDE',
  DISTINCTION = 'DISTINCTION',
  CREDIT = 'CREDIT',
  PASS = 'PASS',
  MERIT = 'MERIT',
  OTHERS = 'OTHERS',
}

export enum UNIVERSITY_CATEGORY {
  CHINA_MAINLAND = 'CHINA_MAINLAND',
  OVERSEAS = 'OVERSEAS',
}

export enum ACADEMIC_REFEREE_STATUS {
  CREATED = 'CREATED',
  SUBMITTED = 'SUBMITTED',
  EXPIRED = 'EXPIRED',
}
